import { gql } from 'graphql-tag'
import { BRIEFING_POST_TYPE_SINGULAR_NAMES } from '~/constants/briefings'

const getBriefingBySlug = (params: {
  postTypePlural: string
  slug: string
}) => {
  const postTypePlural =
    BRIEFING_POST_TYPE_SINGULAR_NAMES[params.postTypePlural] || null

  if (!postTypePlural) return gql()

  return gql`
  query getBriefingBySlug {
    ${postTypePlural}(id: "${params.slug}", idType: SLUG) {
        title
        slug
        date
        viewerCanRead
        content
        briefings {
            estimatedReadingTime
            publicationFrequency
        }
    }
  }
  `
}

export default getBriefingBySlug
